module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMessage),
      expression: "showMessage"
    }]
  }, [_c('group', [_c('cell', {
    attrs: {
      "title": "头像",
      "is-link": true
    }
  }, [_c('img', {
    staticClass: "user-profile",
    attrs: {
      "src": _vm.$store.state.baseurl + _vm.$store.state.avatar
    }
  })])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "昵称",
      "is-link": true,
      "link": "/personalcenter/personalinfo/changenick"
    }
  }, [_c('span', {
    staticClass: "info",
    attrs: {
      "title": _vm.nickname
    }
  }, [_vm._v(_vm._s(_vm.nickname))])])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "性别",
      "is-link": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.choiceSex($event)
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.sex))])])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "手机号码",
      "is-link": true,
      "link": "/personalcenter/personalinfo/changephone"
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.mobile))])])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "更改密码",
      "is-link": true,
      "link": "/changepassword"
    }
  }, [_c('span', {
    staticClass: "info"
  })])], 1), _vm._v(" "), _c('group', [_c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWithdrew),
      expression: "showWithdrew"
    }],
    nativeOn: {
      "click": function($event) {
        _vm.link($event)
      }
    }
  }, [_vm._v("退出登录")])], 1), _vm._v(" "), _c('actionsheet', {
    attrs: {
      "show-cancel": true,
      "menus": _vm.sexmenus
    },
    on: {
      "on-click-menu": _vm.changeSex
    },
    model: {
      value: (_vm.showsex),
      callback: function($$v) {
        _vm.showsex = $$v
      },
      expression: "showsex"
    }
  }), _vm._v(" "), _c('actionsheet', {
    attrs: {
      "show-cancel": true,
      "menus": _vm.profilemenus
    },
    on: {
      "on-click-menu": _vm.closeProfile
    },
    model: {
      value: (_vm.showprofile),
      callback: function($$v) {
        _vm.showprofile = $$v
      },
      expression: "showprofile"
    }
  }), _vm._v(" "), _c('upload-img')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7a40b5aa"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personalcenter/children/personalInfo/index.vue
// module id = 183
// module chunks = 60